<template>
  <div>
    <v-radio-group v-model="categorySynced" data-testid="category-group">
      <template v-for="[cat, r] in reasons">
        <v-radio :key="cat" :label="cat" :value="cat" :data-testid="categoryTestId(cat)" name="category" required></v-radio>
        <v-radio-group required v-model="reasonSynced" v-if="categorySynced == cat" :key="`${cat}-reasons`" data-testid="reason-group" class="ml-8" style="margin-top: -0.5rem">
          <v-radio v-for="reason of r" :key="reason" :label="reason" :value="reason" :data-testid="reasonTestId(reason, cat)" name="reason" required></v-radio>
        </v-radio-group>
      </template>
    </v-radio-group>
  </div>
</template>

<script lang="ts">
import { Vue, Component, PropSync } from 'vue-property-decorator'

import reasons from '@/reasons'
import {
  ReasonCategory,
  NotScamReason,
  ScamReason,
  WrongCategoryReason
} from '@/types'

const categoryTestIds: Record<string, string> = {
  [ReasonCategory.NotScamLikely]: 'radio-category-not-scam',
  [ReasonCategory.ScamLikely]: 'radio-category-scam',
  [ReasonCategory.WrongCategory]: 'radio-category-wrong'
}

function getReasonTestId (reason: string, category: string | null): string {
  if (reason === ScamReason.Other) {
    return category === ReasonCategory.ScamLikely
      ? 'radio-reason-scam-other'
      : 'radio-reason-wrong-other'
  }

  const map: Record<string, string> = {
    [NotScamReason.KnowPersonally]: 'radio-reason-know-personally',
    [NotScamReason.PriorEngagement]: 'radio-reason-prior-engagement',
    [NotScamReason.EventNotification]: 'radio-reason-event-notification',
    [ScamReason.IRS]: 'radio-reason-scam-irs',
    [ScamReason.CreditCard]: 'radio-reason-scam-credit-card',
    [ScamReason.Debt]: 'radio-reason-scam-debt',
    [ScamReason.PC]: 'radio-reason-scam-pc',
    [WrongCategoryReason.Telemarketing]: 'radio-reason-telemarketing',
    [WrongCategoryReason.Political]: 'radio-reason-political',
    [WrongCategoryReason.Survey]: 'radio-reason-survey',
    [WrongCategoryReason.Charity]: 'radio-reason-charity',
    [WrongCategoryReason.Prison]: 'radio-reason-prison',
    [WrongCategoryReason.PotentialSpam]: 'radio-reason-potential-spam'
  }

  return map[reason] || 'radio-reason-unknown'
}

@Component
export default class WhatWentWrong extends Vue {
  @PropSync('category', { required: false })
  private categorySynced!: string | null

  @PropSync('reason', { required: false })
  private reasonSynced!: string | null

  private get reasons () {
    return reasons
  }

  private categoryTestId (cat: string): string {
    return categoryTestIds[cat] || 'radio-category-unknown'
  }

  private reasonTestId (reason: string, category: string): string {
    return getReasonTestId(reason, category)
  }
}
</script>
